import { defineComponent as t, createBlock as r, openBlock as a, unref as l, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconMegaphone",
  __name: "IconMegaphone",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (d, e) => (a(), r(l(i), p(n, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "m18.94 3.706-5.117 2.559H7.5a4.25 4.25 0 0 0-.88 8.408l1.095 4.087a2.25 2.25 0 0 0 4.347-1.165l-.759-2.83h2.52l5.118 2.559a1.25 1.25 0 0 0 1.809-1.119V4.825a1.25 1.25 0 0 0-1.81-1.118m.31 1.522-4.5 2.25v6.073l4.5 2.25V5.228m-9.5 9.537H8.197l.967 3.607a.75.75 0 0 0 1.449-.389L9.75 14.765m-2.25-7a2.75 2.75 0 1 0 0 5.5h5.75v-5.5H7.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
